/* Property listings: client-side filter + sort.
   Filters build from tag data attributes rendered by the collection template.
   Within a group, selected values are OR'd; across groups they are AND'd. */
(function () {
  var root = document.querySelector('[data-pl-root]');
  if (!root) return;

  var grid = root.querySelector('[data-pl-grid]');
  var cards = Array.prototype.slice.call(root.querySelectorAll('[data-pl-card]'));
  var chips = Array.prototype.slice.call(root.querySelectorAll('.pl-chip'));
  var sortSelect = root.querySelector('[data-pl-sort]');
  var countEl = root.querySelector('[data-pl-count]');
  var clearBtn = root.querySelector('[data-pl-clear]');
  var emptyEl = root.querySelector('[data-pl-empty]');
  var total = cards.length;

  // Precompute each card's tag tokens + sort keys once.
  cards.forEach(function (card, i) {
    card._tokens = (card.getAttribute('data-tags') || '')
      .split('|')
      .filter(Boolean);
    card._price = parseFloat(card.getAttribute('data-price')) || 0;
    card._date = parseFloat(card.getAttribute('data-date')) || 0;
    card._order = i; // original ("featured") order
  });

  function activeFiltersByGroup() {
    var groups = {};
    chips.forEach(function (chip) {
      if (chip.getAttribute('aria-pressed') === 'true') {
        var g = chip.getAttribute('data-filter-group');
        (groups[g] = groups[g] || []).push(chip.getAttribute('data-filter-value'));
      }
    });
    return groups;
  }

  function cardMatches(card, groups) {
    for (var g in groups) {
      if (!Object.prototype.hasOwnProperty.call(groups, g)) continue;
      var wanted = groups[g];
      var hit = wanted.some(function (v) { return card._tokens.indexOf(v) !== -1; });
      if (!hit) return false; // this group has selections but card satisfies none
    }
    return true;
  }

  function apply() {
    var groups = activeFiltersByGroup();
    var hasActive = Object.keys(groups).length > 0;

    var visible = cards.filter(function (card) {
      var show = cardMatches(card, groups);
      card.hidden = !show;
      return show;
    });

    // Sort the visible cards, then re-append in order.
    var mode = sortSelect ? sortSelect.value : 'featured';
    visible.sort(function (a, b) {
      switch (mode) {
        case 'price-asc': return a._price - b._price;
        case 'price-desc': return b._price - a._price;
        case 'newest': return b._date - a._date;
        default: return a._order - b._order;
      }
    });
    visible.forEach(function (card) { grid.appendChild(card); });

    // Meta + empty state.
    if (countEl) {
      countEl.textContent = hasActive
        ? visible.length + ' of ' + total + ' ' + (total === 1 ? 'property' : 'properties')
        : total + ' ' + (total === 1 ? 'property' : 'properties');
    }
    if (clearBtn) clearBtn.classList.toggle('is-visible', hasActive);
    if (emptyEl) emptyEl.hidden = visible.length !== 0;
    if (grid) grid.style.display = visible.length === 0 ? 'none' : '';
  }

  chips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      var pressed = chip.getAttribute('aria-pressed') === 'true';
      chip.setAttribute('aria-pressed', pressed ? 'false' : 'true');
      apply();
    });
  });

  if (sortSelect) sortSelect.addEventListener('change', apply);

  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      chips.forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
      if (sortSelect) sortSelect.value = 'featured';
      apply();
    });
  }

  apply();
})();
